import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../tooltip/Tooltip.jsx';
import s from './MapNoteSheet.module.scss';

const renderTrashIcon = onTrash => (
    <button data-testid="delete-map-note-button" className={classNames('icon-trash', s.trashIcon, s.headerIcons)} onClick={onTrash} type="button">
        <Tooltip arrowPosition="right" text="Delete Note" />
    </button>
);

const MapNoteHeader = props => {
    const userCreatedNote = props.mapNote && props.userEmail === props.mapNote.createdBy.email;
    const hasNote = props.mapNote;
    return (
        <div className={s.header}>
            <div className={classNames('icon-newmapnote', s.headerIcons)} />
            <div className={s.noteTitle}>{hasNote ? `Note #${props.mapNote.id}` : 'New Note'}</div>
            {userCreatedNote && renderTrashIcon(props.onTrash)}
            <button className={classNames('icon-mapnote', s.editIcon, s.headerIcons)} onClick={props.onEdit} type="button">
                <Tooltip arrowPosition="right" text="Edit Note Details" />
            </button>
            <button className={classNames('icon-close', s.closeIcon, s.headerIcons)} onClick={props.onClose} type="button">
                <Tooltip arrowPosition="right" text="Close Note" />
            </button>
        </div>
    );
};

MapNoteHeader.propTypes = {
    mapNote: PropTypes.object,
    userEmail: PropTypes.string,
    onTrash: PropTypes.func,
    onEdit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
MapNoteHeader.defaultProps = {
    mapNote: null,
    userEmail: 'test@test.com',
    onTrash: () => {},
};

export default MapNoteHeader;
